module.exports = __webpack_public_path__ + "static/media/visuel09.a0d37462.jpg";